<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">List of Banner</h2>

        <small class="text-muted">Manage all your banner here. </small>
      </div>

      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="handleAdd"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon> Create
          Content
        </span>
      </base-button>
    </div>
    <ServiceBannerTable />
  </b-card>
</template>

<script>
import ServiceBannerTable from "./components/ServiceBannerTable.vue";

export default {
  components: {
    ServiceBannerTable,
  },
  methods: {
    handleAdd() {
      this.$router.push({ name: "addbannercontent" });
    },
  },
};
</script>
<style></style>
